/****************************************
	Callout
*****************************************/
;(function ($) {
	'use strict';
	/* Callout defaults */
	var defaults = {
		'allowClick': false, /* Default behavior is for callout triggers to simply toggle the callout and prevent default. This option allows for the second click on a trigger to propagate up and possibly change the page. */
		'style': 'light', /* 'light' (default) | 'dark' | 'alt' */
		'type': 'click', /* 'click' (default) | 'hover' | 'cursor' (follows mouse) | 'custom' (bind your own events) */
		'content': '', /* Accepts string / text, HTML, or element selector */
		'classes': '', /* Class(es) to add to #calloutContent (separate with space, no dot) */
		'calloutClasses': '', /* Class(es) to add to .callout (separate with space, no dot) */
		'disableAutofocusOnOpen': false, /* Boolean. Set to true to manually handle focus on open */
		'position': 'bottom', /* Position of callout relative to trigger: 'bottom' (default) | 'left' | 'right' */
		'align': 'center', /* Direction callout "flows" to (relative to trigger): 'center' (default) | 'left' | 'right' (Does not apply to { position: 'left' } or { position: 'right' }) */
		'hidePointer': false, /* Set to true to hide pointer */
		'keepContentInPlace': true, /* True keeps content in DOM; False removes it from DOM */
		'showDelay': 100, /* Show delay time in ms for 'hover' callouts */
		'hideDelay': 100, /* Hide delay time in ms for 'hover' callouts */
		'onOpen': false, /* function ($trigger) { } Callback to run *before* callout opens */
		'onAfterOpen': false, /* function ($trigger) { } Callback to run *after* callout opens */
		'onClose': false, /* function ($trigger) { } Callback to run *before* callout closes */
		'debounceTime': 250 /* milliseconds for debounce time */
	},
	closeTimer,
	showDelayTimer,
	isTouchDevice = 'ontouchstart' in window || (window.DocumentTouch && document instanceof DocumentTouch),
	$html = $('html'),
	scrollable = false,
	version = 1,
	doubleIncluded = !!$.callout;
	if (doubleIncluded) {
		if ($.callout.version === version) {
			if (window.console) {
				console.warn('ERROR: You are including callout.js multiple times');
			}
			return;
		} else {
			if (window.console) {
				console.warn('ERROR: You are including multiple versions of callout.js');
			}
			if ($.callout.version > version) {
				return;
			}
		}
	}
	$.fn.callout = function (options) {
		return this.each(function () {
			var $trigger = $(this),
				$window = $(window),
				isInputField,
				hideDelayTimer,
				calloutWrap,
				calloutContent,
				calloutPointer,
				calloutDefaultWidth,
				calloutMinWidth,
				modalHeight = false,
				modalScrollPos = 0,
				windowPadding = 8, /* Space callouts leave on each side of window */
				calloutTouches = {},
				settings = $.extend({}, defaults, options);
			/* visible, focusable, and tabbable functions for accessibility when opening a callout */
			function visible(element) {
				return $.expr.filters.visible(element) &&
					!$(element).parents().andSelf().filter(function () {
						return $.css(this, 'visibility') === 'hidden';
					}).length;
			}
			function focusable(element, isTabIndexNotNaN) {
				var map,
					mapName,
					img,
					nodeName = element.nodeName.toLowerCase();
				if ('area' === nodeName) {
					map = element.parentNode;
					mapName = map.name;
					if (!element.href || !mapName || map.nodeName.toLowerCase() !== 'map') {
						return false;
					}
					img = $('img[usemap=#' + mapName + ']')[0];
					return !!img && visible(img);
				}
				return (/input|select|textarea|button|object/.test(nodeName) ? !element.disabled : 'a' === nodeName ? element.href || isTabIndexNotNaN : isTabIndexNotNaN) && visible(element);
			}
			function getTabbableElements ($container) {
				return $container
					.find('input, select, textarea, button, a, object, [tabindex]')
					.filter(function () {
						return tabbable(this);
					});
			}
			function tabbable(element) {
				var tabIndex = $.attr(element, 'tabindex'),
					isTabIndexNaN = isNaN(tabIndex);
				return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
			}
			function resetCalloutContent() {
				calloutWrap
					.add(calloutContent)
					.add(calloutPointer)
					.removeAttr('style class');
				calloutContent
					.removeAttr('role')
					.off('keydown.callout')
					.addClass('calloutContent');
				calloutWrap.addClass('callout');
				calloutPointer.addClass('calloutPointer');
				$('#modal, html')
					.add(window)
					.add(calloutWrap)
					.off('.callout');
			}
			function hideCallout(runOnClose) {
				var $openCalloutTrigger = $('.calloutTrigger.active'),
					openCalloutSettings = $openCalloutTrigger.data('callout-settings'),
					focusIsWithinCallout = calloutContent.find(':focus').length;
				if (!$openCalloutTrigger.length) { /* Callout was already closed */
					return;
				}
				if (runOnClose && openCalloutSettings.onClose !== false) {
					openCalloutSettings.onClose($openCalloutTrigger);
				}
				resetCalloutContent();
				if (openCalloutSettings.keepContentInPlace) {
					$('#calloutContentPlaceholder').replaceWith($(openCalloutSettings.content));
				} else {
					calloutContent
						.children()
						.remove();
				}
				/* Deactivate active trigger */
				$openCalloutTrigger
					.removeClass('hover active')
					.attr('aria-expanded', false);
				/* Handle scrollable containers */
				if (scrollable) {
					$openCalloutTrigger
						.closest('.calloutScrollPane')
						.off('scroll.callout');
				}
				if (modalHeight !== false) {
					if ($('html').hasClass('modalOpen')) {
						$('body, #modal').css('height', modalHeight);
					}
					$('#modalCenter').css('height', '');
					modalHeight = false;
					$('#modal').removeData('preventModalCenterOnResize');
				}
				if (focusIsWithinCallout) {
					$openCalloutTrigger.focus();
				}
			}
			function setModalHeightOnTouchDevices() {
				var $modalCenter = $('#modalCenter'),
					heightCurrentlyAvailable = $('body').outerHeight(true),
					heightNeededToShowCallout = calloutWrap.offset().top + calloutContent.outerHeight(true);
				if (heightCurrentlyAvailable < heightNeededToShowCallout) {
					modalHeight = heightCurrentlyAvailable;
					$modalCenter.css('height', $modalCenter.css('height'));
					$('body, #modal').css('height', heightNeededToShowCallout);
					$('#modal').data('preventModalCenterOnResize', true);
				}
			}
			function setModalHeightOnNonTouchDevices() {
				var $modalContents = $('#modalContents'),
					heightNeededToShowCallout = calloutWrap.offset().top + calloutContent.outerHeight(true),
					heightCurrentlyAvailable = $modalContents.outerHeight(false) + $modalContents.offset().top,
					extraSpaceNeeded = Math.max(heightNeededToShowCallout - heightCurrentlyAvailable, 0);
				$modalContents.css('margin-bottom', extraSpaceNeeded);
			}
			function positionCallout(position, align, lastRun) {
				var windowWidth = $window.outerWidth(false),
					triggerHeight = $trigger.outerHeight(false),
					triggerWidth = $trigger.outerWidth(false),
					triggerPos = $trigger.offset(),
					leftOfTrigger = triggerPos.left,
					centerOfTrigger = leftOfTrigger + (triggerWidth / 2),
					rightOfTrigger = leftOfTrigger + triggerWidth,
					topOfTrigger = triggerPos.top,
					bottomOfTrigger = topOfTrigger + triggerHeight,
					calloutTempWidth = calloutContent.outerWidth(false),
					calloutInputOffset = 16, /* from CSS: .callout margin-left + .calloutContent left (for .calloutCursor) */
					calloutOffset = 24, /* from CSS: .calloutContent left or right value */
					inModal = $trigger.closest('#modal').length > 0,
					calloutContentHeight,
					calloutIsPastModalArea,
					minTriggerHeight = 42; /* This needs to be the offset of the arrow * 2 + the height of the arrow as defined in the CSS */
				/* Reset position */
				calloutWrap
					.removeClass('calloutPositionBottom calloutPositionTop calloutPositionLeft calloutPositionRight calloutAlignLeft calloutAlignCenter calloutAlignMiddle calloutAlignRight calloutAlignTop calloutAlignBottom')
					.add(calloutContent)
					.add(calloutPointer)
					.removeAttr('style');
				/* Set default width */
				calloutContent.css({ 'width': calloutDefaultWidth });
				if (isInputField) {
					var leftCorrect = 0,
						minimumMaxWidth = 180, /* Minimum width for a multi-line callout (preserves readability) */
						widthAvailable = windowWidth - (leftOfTrigger + 10); /* 10px from right edge of page */
					if (minimumMaxWidth > widthAvailable) {
						leftCorrect = Math.min(minimumMaxWidth, calloutDefaultWidth) - widthAvailable;
					}
					/* Input field tooltip */
					calloutContent.css({
						'max-width': Math.max(triggerWidth, minimumMaxWidth),
						'width': calloutDefaultWidth
					});
					calloutWrap
						.addClass('calloutPositionBottom')
						.css({
							'left': leftOfTrigger - leftCorrect,
							'top': bottomOfTrigger
						});
				} else if (settings.type === 'cursor') {
					/* Cursor callout */
					calloutContent.css('width', calloutTempWidth);
					$trigger.on('mousemove.callout', function (e) {
						calloutWrap
							.css({
								'left': Math.max(calloutInputOffset + windowPadding, Math.min(e.pageX, windowWidth - windowPadding - calloutContent.outerWidth(false) + calloutInputOffset)),
								'top': e.pageY
							});
						if (e.pageX > windowWidth + calloutInputOffset - calloutContent.outerWidth(false)) {
							calloutPointer.css({ 'left': Math.min(e.pageX - calloutWrap.offset().left - (calloutInputOffset / 2), calloutContent.outerWidth(false) - 48) }); /* 48 = keeps pointer centered inside of callout */
						} else {
							calloutPointer.css({ 'left': 0 });
						}
					});
					calloutWrap.addClass('calloutPositionBottom');
				} else {
					/* Sets callout's default position */
					if (!position) {
						position = settings.position;
					}
					/* Sets callout's default alignment */
					if (!align) {
						align = settings.align;
					}
					calloutWrap.css({ 'left': centerOfTrigger });
					/* Align callout content */
					switch (align) {
						case ('left'):
							calloutWrap.addClass('calloutAlignLeft');
							calloutContent.css({
								'max-width': Math.max(centerOfTrigger + calloutOffset - windowPadding, calloutMinWidth),
								'right': (triggerWidth < parseInt(calloutPointer.css('width'), 10)) ? -calloutOffset : -triggerWidth / 2
							});
							break;
						case ('right'):
							calloutWrap.addClass('calloutAlignRight');
							calloutContent.css({
								'left': -triggerWidth / 2,
								'max-width': Math.max(windowWidth - centerOfTrigger + calloutOffset - windowPadding, calloutMinWidth)
							});
							break;
						default:
							if (position === 'left' || position === 'right') {
								switch (align) {
									case ('top'):
										calloutWrap.addClass('calloutAlignTop');
										if (triggerHeight < minTriggerHeight) {
											calloutWrap.css({ 'top': topOfTrigger - (minTriggerHeight - triggerHeight) / 2});
										} else {
											calloutWrap.css({ 'top': topOfTrigger});
										}
										break;
									case ('bottom'):
										calloutWrap.addClass('calloutAlignBottom');
										if (triggerHeight < minTriggerHeight) {
											calloutWrap.css({ 'top': bottomOfTrigger + (minTriggerHeight - triggerHeight) / 2});
										} else {
											calloutWrap.css({ 'top': bottomOfTrigger});
										}
										break;
									default:
										calloutWrap
											.addClass('calloutAlignMiddle')
											.css({ 'top': topOfTrigger + (triggerHeight / 2) - (calloutWrap.outerHeight(false) / 2) });
										calloutContent.css({ 'top': '-' + (calloutContent.outerHeight(false) / 2) + 'px' });
										break;
								}
							} else {
								calloutWrap.addClass('calloutAlignCenter');
								calloutContent.css({ 'left': -Math.abs(calloutContent.outerWidth(false) / 2) });
								/* Tweak if off page right */
								if (calloutContent.offset().left + calloutContent.outerWidth(false) - $(document).scrollLeft() > windowWidth) {
									calloutContent.css({
										'left': -Math.abs(calloutContent.outerWidth(false) / 2) + (windowWidth - calloutContent.offset().left - calloutContent.outerWidth(false)) + $(document).scrollLeft() - windowPadding,
										'max-width': windowWidth - (windowPadding * 2)
									});
								}
								/* Tweak if off page left */
								if (calloutContent.offset().left < 0) {
									calloutContent.css({
										'left': -Math.abs(leftOfTrigger) - (triggerWidth / 2) + windowPadding,
										'max-width': windowWidth - (windowPadding * 2)
									});
								}
							}
					}
					/* Position the callout content */
					switch (position) {
						case 'left':
							calloutWrap
								.addClass('calloutPositionLeft')
								.css({ 'left': leftOfTrigger - calloutWrap.outerWidth(false) });
							calloutContent.css({ 'max-width': Math.max(leftOfTrigger - windowPadding - parseInt(calloutContent.css('margin-left'), 10) - parseInt(calloutContent.css('margin-right'), 10), calloutMinWidth) });
							break;
						case 'right':
							calloutWrap
								.addClass('calloutPositionRight')
								.css({ 'left': rightOfTrigger });
							calloutContent.css({ 'max-width': Math.max(windowWidth - rightOfTrigger - windowPadding - parseInt(calloutContent.css('margin-left'), 10) - parseInt(calloutContent.css('margin-right'), 10), calloutMinWidth) });
							break;
						case 'top':
							calloutWrap
								.addClass('calloutPositionTop')
								.css({ 'top': topOfTrigger - calloutWrap.outerHeight(false) });
							break;
						default:
							calloutWrap
								.addClass('calloutPositionBottom')
								.css({ 'top': bottomOfTrigger });
					}
					/* Tweak vertical position if out of viewport */
					calloutContentHeight = calloutContent.outerHeight(false);
					/* If callout is off-bottom... */
					if (calloutContent.offset().top + calloutContentHeight > $window.scrollTop() + $window.outerHeight(false)) {
						if (position === 'left' || position === 'right') {
							calloutContent.css({ 'top': Math.max(parseInt(calloutContent.css('top'), 10) - (calloutContent.offset().top + calloutContentHeight - $window.scrollTop() - $window.outerHeight(false) + windowPadding), -Math.abs(calloutContentHeight - calloutOffset)) });
						}
					}
					/* If callout is off-top... */
					if (calloutContent.offset().top < $window.scrollTop()) {
						if (position === 'left' || position === 'right') {
							calloutContent.css({ 'top': Math.min(parseInt(calloutContent.css('top'), 10) + ($window.scrollTop() - calloutContent.offset().top + windowPadding), -Math.abs(calloutOffset)) });
						}
						/* If position === top, position bottom */
						if (position === 'top' && !lastRun) {
							positionCallout('bottom', 'center', true);
						}
					}
					/* Tweak horizontal position if out of viewport */
					if (calloutContent.offset().left < 0 || windowWidth < calloutContent.offset().left + calloutContent.outerWidth(false)) {
						if (!lastRun) {
							positionCallout((settings.position === 'left' || settings.position === 'right') ? 'bottom' : settings.position, 'center', true);
						}
					}
					/* Adjust modal height so callout is fully visible. */
					if (inModal && !lastRun && calloutWrap.hasClass('calloutPositionBottom')) {
						if (isTouchDevice) {
							calloutIsPastModalArea = calloutContent.offset().top + calloutContent.outerHeight(false) > $('#modal').height();
							if (calloutIsPastModalArea) {
								setModalHeightOnTouchDevices();
							}
						} else {
							calloutIsPastModalArea = $('#modal').scrollTop() + calloutContent.offset().top + calloutContent.outerHeight(false) - Math.max($('body').scrollTop(), $html.scrollTop()) > Math.max($('#modal').outerHeight(false), $('#modalContents').outerHeight(false));
							if (calloutIsPastModalArea) {
								setModalHeightOnNonTouchDevices();
							}
						}
					}
				}
			}
			function resetShowTimer() {
				if (showDelayTimer) {
					clearTimeout(showDelayTimer);
					showDelayTimer = null;
				}
			}
			function hideDelay() {
				hideDelayTimer = setTimeout(function () {
					if (!$('.calloutTrigger').hasClass('hover') && !calloutWrap.hasClass('hover')) {
						resetShowTimer();
						hideCallout(true);
					}
				}, settings.hideDelay);
			}
			function resetHideTimer() {
				if (hideDelayTimer) {
					clearTimeout(hideDelayTimer);
					hideDelayTimer = null;
				}
			}
			function handleTabPress() {
				$('#calloutContent')
					.off('keydown.callout')
					.on('keydown.callout', function (e) {
						var tabbableElements,
							focusedElement,
							$this = $(this);
						if (e.keyCode === 9) {
							tabbableElements = getTabbableElements($this);
							focusedElement = $this.find(':focus') || $this;
							if ((e.shiftKey && (focusedElement.get(0) === tabbableElements.first().get(0) || $('#calloutContent:focus').length)) || (!e.shiftKey && focusedElement.get(0) === tabbableElements.last().get(0)) || (focusedElement.eq(0).is('[type="radio"]') && ((e.shiftKey && focusedElement.eq(0).attr('name') === tabbableElements.first().eq(0).attr('name')) || (!e.shiftKey && focusedElement.eq(0).attr('name') === tabbableElements.last().eq(0).attr('name'))))) {
								$trigger.focus();
								hideCallout(true);
							}
						}
					});
			}
			function focusOnCallout() {
				var newScrollTop,
					oldScrollTop,
					$body;
				/* Focus on callout contents and remove event on blur if it is not an input */
				if ($trigger.is('input, textarea')) {
					return;
				}
				$body = $('body');
				oldScrollTop = Math.max($body.scrollTop(), $html.scrollTop());
				$('#calloutContent').focus();
				newScrollTop = Math.max($body.scrollTop(), $html.scrollTop());
				if (newScrollTop !== oldScrollTop) {
					$('body, html').scrollTop(oldScrollTop);
				}
			}
			function resetDefaultWidth() {
				var result = Math.ceil(calloutWrap
					.css({
						'display': 'block',
						'left': '0',
						'top': '0',
						'width': 'auto'
					})
					.find(calloutContent)
					.css({
						'position': 'relative',
						'width': 'auto'
					})[0].getBoundingClientRect().width);
				return result;
			}
			function debounce(func, wait, immediate) {
				var timeout;
				return function() {
					var context = this,
						args = arguments,
						later = function() {
							timeout = null;
							if (!immediate) {
								func.apply(context, args);
							}
						},
						callNow = immediate && !timeout;
					clearTimeout(timeout);
					timeout = setTimeout(later, wait);
					if (callNow) {
						func.apply(context, args);
					}
				};
			}
			function showCallout() {
				var preventClose = false,
					$scrollableContainer;
				clearTimeout(closeTimer);
				/* Store settings onto trigger for use in the hideCallout function */
				$trigger.data('callout-settings', settings);
				/* Add content to callout */
				if (settings.keepContentInPlace) {
					$trigger.data('callout-content').before('<span id="calloutContentPlaceholder" style="display:none;"></span>');
				}
				calloutContent.html($trigger.data('callout-content'));
				/* Add html click event */
				if (!calloutWrap.hasClass('calloutTypeCursor') && settings.type !== 'custom') {
					$html
						.on('touchstart.callout', function (e) {
							calloutTouches.x = e.originalEvent.touches ? e.originalEvent.touches[0].pageX : e.pageX;
							calloutTouches.y = e.originalEvent.touches ? e.originalEvent.touches[0].pageY : e.pageY;
						})
						.on('click.callout touchend.callout', function (e) {
							var $target = $(e.srcElement || e.target || e.originalEvent.originalTarget),
								targetInAutocomplete = $target.closest('.autocompleteResult').length > 0,
								targetIsWithinCallout = $target.closest('#callout').length > 0;
							if (!preventClose && !targetIsWithinCallout && !targetInAutocomplete) {
								if (e.type === 'click') {
									hideCallout(true);
								} else if (!isInputField && Math.max(Math.abs(calloutTouches.x - e.originalEvent.changedTouches[0].pageX), Math.abs(calloutTouches.y - e.originalEvent.changedTouches[0].pageY)) < 5) {
									closeTimer = setTimeout(function () {
										hideCallout(true);
										preventClose = false;
									}, 500);
									preventClose = true;
								}
							}
						});
				}
				/* Add callout hover events */
				if (settings.type === 'hover' || settings.type === 'cursor') {
					calloutWrap
						.on('mouseenter.callout', function () {
							calloutWrap.addClass('hover');
							resetHideTimer();
						})
						.on('mouseleave.callout', function () {
							calloutWrap.removeClass('hover');
							hideDelay();
						});
				}
				/* Run onOpen */
				if (settings.onOpen !== false) {
					settings.onOpen($trigger);
				}
				/* Set callout style */
				if (settings.style === 'dark') {
					calloutWrap.addClass('calloutStyleDark bgDark');
				} else if (settings.style === 'alt') {
					calloutWrap.addClass('calloutStyleAlt');
				} else if (settings.style === 'guidance') {
					calloutWrap.addClass('calloutStyleGuidance');
				}
				/* Add custom classes */
				if (settings.classes) {
					calloutContent.addClass(settings.classes);
				}
				if (settings.calloutClasses) {
					calloutWrap.addClass(settings.calloutClasses);
				}
				if ($trigger.attr('data-callout-classes')) {
					calloutContent.addClass($trigger.attr('data-callout-classes'));
				}
				if ($trigger.attr('data-callout-wrap-classes')) {
					calloutContent.addClass($trigger.attr('data-callout-wrap-classes'));
				}
				/* Show / hide pointer */
				if (settings.hidePointer) {
					calloutWrap.addClass('calloutHidePointer');
				}
				/* Set original width (once) */
				if (!calloutDefaultWidth || $trigger.data('callout-updated')) {
					if (isInputField) {
						/* Removes default max-width from CSS */
						calloutContent.css({ 'max-width': 'none' });
					}
					calloutDefaultWidth = resetDefaultWidth();
					calloutWrap
						.add(calloutContent)
						.removeAttr('style');
					$trigger.removeData('callout-updated');
				}
				/* Activate callout */
				calloutWrap.addClass('active');
				/* Callout type */
				if (isInputField) {
					calloutWrap.addClass('calloutTypeInput');
				}
				if (settings.type === 'cursor') {
					calloutWrap.addClass('calloutTypeCursor');
					calloutContent.css({ 'width': Math.min(parseInt(calloutDefaultWidth, 10), $window.outerWidth(false) - (windowPadding * 2)) });
				}
				positionCallout();
				/* Adjust z-index if inside of modal */
				if ($trigger.closest('#modal').length > 0) {
					$('#modal').on('recentered', function () {
							positionCallout();
							adjustCalloutInModal();
						});
					adjustCalloutInModal();
					/* Scroll event inside modal */
					$('#modal').on('scroll.callout', function () {
						calloutWrap.css({ 'margin-top': -$(this).scrollTop() });
					});
				}
				$trigger
					.addClass('hover active')
					.attr('aria-expanded', true);
				handleTabPress();
				if (settings.onAfterOpen !== false) {
					settings.onAfterOpen($trigger);
				}
				if (settings.disableAutofocusOnOpen !== true) {
					if (settings.type === 'hover' || !getTabbableElements(calloutContent).length) {
						calloutContent.attr('role', 'alert');
					} else if (!calloutContent.find(':focus').length) {
						focusOnCallout();
					}
				}
				/*	Hide on browser resize. Samsung S3 fires resize when keyboard is opened.
					So if a callout is auto-focusing on an input onOpen, this will cause the
					callout to close. TODO: Need to revisit this. */
				$window.on((isTouchDevice ? 'orientationchange' : 'resize') + '.callout', function () {
					if (calloutWrap.hasClass('active') && !calloutWrap.hasClass('calloutStyleGuidance')) {
						hideCallout(false);
					}
				});
				/* Handle scrollable containers */
				if (scrollable) {
					$scrollableContainer = $trigger.closest('.calloutScrollPane');
					$scrollableContainer.on('scroll.callout', debounce(function () {
						if (stillInView($trigger, $scrollableContainer)) {
							positionCallout();
						} else {
							hideCallout();
						}
					}, settings.debounceTime));
				}
			}
			function adjustCalloutInModal() {
				modalScrollPos = $('#modal').scrollTop();
				calloutWrap.css({
					'margin-top': -modalScrollPos,
					'top': '+=' + modalScrollPos,
					'z-index': 1010
				});
			}
			function destroyCallout() {
				resetShowTimer();
				if ($trigger.hasClass('active')) {
					hideCallout(true);
				}
				if (!$('.calloutTrigger.active').length && $('#callout.active').length && $('#calloutContent:empty').length) {
					resetCalloutContent();
				}
				$trigger
					.off('.callout')
					.removeClass('calloutTrigger iconAfter iconArrowSmallDownAfter')
					.removeData('callout-content')
					.removeAttr('aria-expanded');
			}
			function showDelay() {
				showDelayTimer = setTimeout(function () {
					if ($('.calloutTrigger.active').not($trigger).length) {
						hideCallout(true);
					}
					if ($trigger.hasClass('hover') && !$trigger.hasClass('active') && !calloutWrap.hasClass('active')) {
						resetHideTimer();
						showCallout();
					}
				}, Math.max(100, settings.showDelay));
			}
			function stillInView($element, $container) {
				var elementHeight = $element.outerHeight(false),
					elementWidth = $element.outerWidth(false),
					elementOffset = $element.offset(),
					containerHeight = $container.outerHeight(false),
					containerWidth = $container.outerWidth(false),
					containerOffset = $container.offset(),
					notAbove = (elementOffset.top + elementHeight) >= containerOffset.top,
					notBelow = (elementOffset.top + elementHeight) <= (containerOffset.top + containerHeight),
					notLeft = elementOffset.left >= containerOffset.left,
					notRight = (elementOffset.left + elementWidth) <= (containerOffset.left + containerWidth);
				return notAbove && notBelow && notLeft && notRight;
			}
			function addEvents() {
				var preventClick = true;
				if (isInputField) {
					$trigger.on(($trigger.is('select') ? 'mouseenter.callout ' : '') + 'focus.callout open.callout', function () {
						showCallout();
					}).on('blur.callout close.callout', function () {
						hideCallout(true);
					}).on('click.callout', function (e) {
						e.stopPropagation();
					});
				} else if (settings.type === 'custom') {
					$trigger
						.on('open.callout', function () {
							showCallout();
						})
						.on('close.callout', function () {
							hideCallout(true);
						});
				} else if (settings.type === 'hover' || settings.type === 'cursor') {
					$trigger
						.on('mouseenter.callout open.callout', function () {
							$trigger.addClass('hover');
							showDelay();
							preventClick = true;
							setTimeout(function () {
								preventClick = false;
							}, 600); /* Magic number after 300ms delay on touch devices */
						})
						.on('mouseleave.callout', function () {
							$trigger.removeClass('hover');
							hideDelay();
						})
						.on('close.callout', function () {
							hideCallout(true);
						});
					if (isTouchDevice) {
						/* If you want the hover callout to be triggered separately
							than the click event, you must use event delegation to
							bind your click event. */
						$trigger.on('click.callout', function () {
							if (preventClick) {
								return false;
							}
						});
					}
				} else {
					$trigger
						.on('click.callout', function (e) {
							if ($trigger.hasClass('active')) {
								/* Hide if $trigger is active */
								hideCallout(true);
								if (settings.allowClick) {
									preventClick = false;
								}
							} else {
								/* Otherwise close other callout, then show */
								if (calloutWrap.hasClass('active')) {
									hideCallout(true);
								}
								showCallout();
							}
							if (preventClick) {
								e.stopImmediatePropagation();
								if ($trigger.is('a')) {
									e.preventDefault();
								}
							}
							preventClick = true;
						})
						.on('open.callout', function () {
							if ($trigger.hasClass('active')) {
								return;
							}
							/* Otherwise close other callout, then show */
							if (calloutWrap.hasClass('active')) {
								hideCallout(true);
							}
							showCallout();
						})
						.on('close.callout', function () {
							hideCallout(true);
						});
				}
				$trigger
					.on('destroy.callout', function () {
						destroyCallout();
					})
					.on('focusCallout.callout', function () {
						focusOnCallout();
					})
					.on('updateContent.callout', function () {
						calloutDefaultWidth = resetDefaultWidth();
						positionCallout();
					})
					.on('updateCalloutSettings.callout', function (e, newTrigger, position, align) {
						$trigger = $(newTrigger);
						settings.position = position || 'bottom';
						settings.align = align || 'center';
						calloutDefaultWidth = resetDefaultWidth();
						positionCallout();
						$trigger.removeClass('hover active');
					})
					.on('position.callout', function () {
						positionCallout();
					});
			}
			function initCallout() {
				/* Add callout to page */
				if (settings.style === 'guidance') {
					$('<div id="calloutGuidance" class="callout"><div id="calloutGuidanceContent" class="calloutContent" tabindex="0"></div><div id="calloutGuidancePointer" class="calloutPointer"><div id="calloutPointerShadow" class="calloutPointerShadow"></div></div></div>').appendTo('body');
					calloutWrap = $('#calloutGuidance');
					calloutContent = $('#calloutGuidanceContent');
					calloutPointer = $('#calloutGuidancePointer');
				} else {
					if (!$('#callout').length) {
						$('<div id="callout" class="callout"><div id="calloutContent" class="calloutContent" tabindex="-1"></div><div id="calloutPointer" class="calloutPointer"><div id="calloutPointerShadow" class="calloutPointerShadow"></div></div></div>').appendTo('body');
					}
					calloutWrap = $('#callout');
					calloutContent = $('#calloutContent');
					calloutPointer = $('#calloutPointer');
				}
				calloutMinWidth = Math.max(240, parseInt(calloutWrap.css('min-width'), 10));
				/* Check where callout content comes from */
				if (settings.content) {
					try {
						if ($(settings.content).closest('body').length) { /* Don't use .find() due to differences between jQuery 1.7 and 1.11 */
							$trigger.data('callout-content', $(settings.content));
							$trigger.data('callout-content').addClass('calloutDomContent');
						} else {
							settings.keepContentInPlace = false;
							$trigger.data('callout-content', settings.content);
						}
					} catch (e) {
						settings.content = '<div>' + settings.content + '</div>';
						settings.keepContentInPlace = false;
						$trigger.data('callout-content', settings.content);
					}
				} else if ($trigger.attr('data-callout')) {
					settings.keepContentInPlace = false;
					$trigger.data('callout-content', $trigger.attr('data-callout'));
				} else if ($trigger.attr('title')) {
					settings.keepContentInPlace = false;
					$trigger.data('callout-content', $trigger.attr('title'));
				} else {
					/* default to space - prevents issue where callout is positioned on the bottom left of the page */
					$trigger.data('callout-content', '&nbsp;');
				}
				/* Re-initialize if already initialized */
				$trigger
					.off('.callout')
					.addClass('calloutTrigger')
					.attr('aria-expanded', false)
					.not('.calloutTooltip')
					.not('.iconLeaf, .iconShakyLeaf, .iconBars, input, select, textarea, .calloutTriggerNoArrow')
					.addClass('iconAfter iconArrowSmallDownAfter')
					.not('.ancBtn')
					.not('.photo')
					.not(':empty')
					.filter(function () {
						var $e = $(this),
							$c = $e.children(),
							$l = $c.length,
							$f = $c.first();
						return $l ? !($l === 1 && $f.is('span') && $.trim($e.text()) === $.trim($f.text())) : $.trim($e.text());
					})
					.wrapInner('<span>');
				/* Settings for form input */
				if ($trigger.is('input, select, textarea')) {
					isInputField = true;
					settings.style = 'dark';
					settings.hidePointer = true;
					settings.position = 'bottom';
				}
				/* Check HTML and update settings */
				if ($trigger.hasClass('calloutStyleDark')) {
					settings.style = 'dark';
				} else if ($trigger.hasClass('calloutStyleAlt')) {
					settings.style = 'alt';
				}
				if ($trigger.hasClass('calloutTypeHover')) {
					settings.type = 'hover';
				} else if ($trigger.hasClass('calloutTypeCursor')) {
					settings.type = 'cursor';
				} else if ($trigger.hasClass('calloutTypeCustom')) {
					settings.type = 'custom';
				}
				if ($trigger.hasClass('calloutPositionTop')) {
					settings.position = 'top';
				} else if ($trigger.hasClass('calloutPositionRight')) {
					settings.position = 'right';
				} else if ($trigger.hasClass('calloutPositionLeft')) {
					settings.position = 'left';
				}
				if ($trigger.hasClass('calloutAlignLeft')) {
					settings.align = 'left';
				} else if ($trigger.hasClass('calloutAlignRight')) {
					settings.align = 'right';
				} else if ($trigger.hasClass('calloutAlignTop')) {
					settings.align = 'top';
				} else if ($trigger.hasClass('calloutAlignBottom')) {
					settings.align = 'bottom';
				}
				if ($trigger.hasClass('calloutHidePointer')) {
					settings.hidePointer = true;
				}
				if ($trigger.closest('.calloutScrollPane').length) {
					scrollable = true;
				}
				/* Add icon to tooltips */
				if ($trigger.hasClass('calloutTooltip')) {
					$trigger
						.addClass('link iconAfter iconHelpAfter')
						.not(':has(span)')
						.not(':empty')
						.wrapInner('<span>');
				}
				addEvents();
			}
			/* Check options or initialize */
			switch (options) {
				case 'destroy':
					$trigger.triggerHandler('destroy.callout');
					break;
				case 'open':
					$trigger.triggerHandler('open.callout');
					break;
				case 'close':
					$trigger.triggerHandler('close.callout');
					break;
				case 'focus':
					$trigger.triggerHandler('focusCallout.callout');
					break;
				default:
					initCallout();
					break;
			}
		});
	};
	$.callout = {
		/* close callout function */
		'close': function () {
			var $trigger = $('.calloutTrigger.active');
			if ($trigger.length) {
				$trigger.triggerHandler('close.callout');
			}
		},
		'content': function ($trigger, newContent) {
			$trigger
				.data('callout-content', newContent)
				.data('callout-updated', true);
			if ($trigger.hasClass('active')) {
				$('#calloutContent').html(newContent);
			}
			$trigger.triggerHandler('updateContent.callout');
		},
		'updateCalloutSettings': function ($trigger, $newTrigger, newContent, position, align) {
			/* this function is required for guidance */
			if (newContent) {
				$trigger
					.data('callout-content', newContent)
					.data('callout-updated', true);
				$('#calloutGuidanceContent').html(newContent);
			}
			$trigger.triggerHandler('updateCalloutSettings.callout', [$newTrigger, position, align]);
		},
		'positionCallout': function ($trigger) {
			/* this function is required for guidance */
			$trigger.triggerHandler('position.callout');
		},
		'version': version
	};
	if (!doubleIncluded) {
		/* Initialize the callout */
		$(function () {
			/* Actually initialize anything with the data-callout attr */
			$('[data-callout]:not([data-auto-instantiate="off"])').callout();
		});
	}
}(jQuery));